module.exports = __webpack_public_path__ + "assets/fefa9d36fbc12525e33e22fc977ebaf1.png";